import { gql, useMutation } from "@apollo/client";

const UPDATE_DESIGNER_BIO = gql`
  mutation UpdateDesignerBio(
    $_id: ID!
    $userName: String
    $yearsExperience: Int
    $aboutMe: String
    $education: [String]
    $whyWorkWithMe: String
    $designAdvice: String
    $favoriteMovie: String
    $favoriteMusicGenre: String
    $favoriteBook: String
    $currentlyReading: String
    $image: ID
    $coverImage: ID
    $coverImagePositionX: Float
    $coverImagePositionY: Float
    $reviews: [DesignerReviewInput!]
  ) {
    updateDesignerBio(
      _id: $_id
      userName: $userName
      yearsExperience: $yearsExperience
      aboutMe: $aboutMe
      education: $education
      whyWorkWithMe: $whyWorkWithMe
      designAdvice: $designAdvice
      favoriteMovie: $favoriteMovie
      favoriteMusicGenre: $favoriteMusicGenre
      favoriteBook: $favoriteBook
      currentlyReading: $currentlyReading
      image: $image
      coverImage: $coverImage
      coverImagePositionX: $coverImagePositionX
      coverImagePositionY: $coverImagePositionY
      reviews: $reviews
    ) {
      aboutMe
      designAdvice
      designerId
      education
      userName
      whyWorkWithMe
      yearsExperience
      favoriteMovie
      favoriteMusicGenre
      favoriteBook
      currentlyReading
      _id
      image
      coverImage
      coverImagePositionX
      coverImagePositionY
      reviews {
        id
        rating
        text
        author
        location
        avatar
        source
        createdAt
      }
    }
  }
`;

export const useUpdateDesignerBioMutation = () => {
  const [updateDesignerBioMutation, { loading, error, data }] =
    useMutation(UPDATE_DESIGNER_BIO);

  const updateDesignerBio = async (args: any) => {
    try {
      const { data } = await updateDesignerBioMutation({
        variables: args,
      });
      return data?.updateDesignerBio;
    } catch (err) {
      console.error("Error updating designer bio:", err);
      throw err;
    }
  };

  return {
    updateDesignerBio,
    loading,
    error,
    data,
  };
};
